import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=5b5b96ce&scoped=true"
import script from "./Search.vue?vue&type=script&lang=ts"
export * from "./Search.vue?vue&type=script&lang=ts"
import style0 from "./Search.vue?vue&type=style&index=0&id=5b5b96ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5b96ce",
  null
  
)

export default component.exports